import script from "./LowResolutionNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./LowResolutionNotice.vue?vue&type=script&setup=true&lang=js"

import "./LowResolutionNotice.vue?vue&type=style&index=0&id=1a9d4977&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a9d4977"]])

export default __exports__